import React, { useEffect, useState } from 'react';
import { FaBars } from 'react-icons/fa';
import AdminSidebar from './AdminSidebar';
import { FaFacebook, FaInstagram, FaLinkedin, FaGlobe, FaTwitter} from "react-icons/fa";

const AdminNavbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [admin, setAdmin] = useState({});

  useEffect(() => {
    const storedAdmin = JSON.parse(localStorage.getItem('admin'));
    if (storedAdmin) {
      setAdmin(storedAdmin);
    }
  }, []);

  return (
    <>
      {/* Sidebar */}
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Top Navbar */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md px-6 py-4 flex items-center justify-between z-40">
        {/* Left: Menu Icon */}
        <div className="flex items-center space-x-4">
          <FaBars
            className="text-2xl cursor-pointer transition duration-300"
            style={{ color: '#113F67' }}
            onClick={() => setSidebarOpen(true)}
          />
        </div>

        {/* Center: Title */}
        <h1
          className="relative md:absolute md:left-1/2 md:transform md:-translate-x-1/2 md:text-3xl text-xl font-extrabold font-mono tracking-wider"
          style={{ color: '#113F67' }}
        >
          <span className="text-4xl font-serif">M</span>
          ission
          <span className="text-4xl font-serif">M</span>
          ap
        </h1>

        {/* Right: Profile */}
        <div className="flex items-center space-x-3">
          <img
            src={admin.profileImage}
            alt="Admin"
            className="w-12 h-12 rounded-full object-cover border-2 border-purple-400"
          />
          <span className="text-gray-700 font-semibold capitalize text-xl">{admin.username}</span>
        </div>

         </div>
    </>
  );
};

      // {/* <footer className="bg-white shadow-lg border-t border-gray-200 fixed bottom-0 left-0 w-full z-50">
      //       <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0">
      
      //         {/* Left side */}
      //         <p className="text-sm text-gray-700 text-center sm:text-left">
      //           © {new Date().getFullYear()}{" "}
      //           <span className="font-bold text-purple-700 hover:text-purple-900 transition-colors duration-200">
      //             Life Changers Ind
      //           </span>{" "}
      //           | All Rights Reserved
      //         </p>
      
      //         {/* Social Links */}
      //         <div className="flex space-x-4 text-gray-600">
      //             <a
      //             href="https://lifechangersind.com"
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             className="hover:text-green-600 transition-colors duration-200"
      //           >
      //             <FaGlobe size={18} />
      //           </a>
      //            <a
      //             href="https://x.com/Lifechangersind?t=Yc8WfiFeA611U-8oLd15sg&s=09"
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             className="hover:text-sky-500 transition-colors duration-200"
      //           >
      //             <FaTwitter size={18} />
      //           </a>
      //           <a
      //             href="https://www.facebook.com/lc.ind.50?mibextid=LQQJ4d"
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             className="hover:text-blue-600 transition-colors duration-200"
      //           >
      //             <FaFacebook size={18} />
      //           </a>
      //           <a
      //             href="https://www.instagram.com/lifechangersind/?hl=en"
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             className="hover:text-pink-500 transition-colors duration-200"
      //           >
      //             <FaInstagram size={18} />
      //           </a>
      //           <a
      //             href="https://www.linkedin.com/in/life-changers-ind-5696b720a/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             className="hover:text-blue-500 transition-colors duration-200"
      //           >
      //             <FaLinkedin size={18} />
      //           </a>
                
      //         </div>
      //       </div>
      //     </footer> */}
               

export default AdminNavbar;
